export enum PageType {
  Archive = "archive",
  Article = "article",
  Author = "author",
  Authors = "authors",
  Explained = "explained",
  Games = "games",
  GamesCrosswords = "games_crosswords",
  GamesMiniSudoku = "games_mini_sudoku",
  GamesWordSearch = "games_word_search",
  Homepage = "homepage",
  Live = "live",
  Newsletter = "newsletter",
  NewsletterPreview = "newsletter_preview",
  Others = "others",
  Page = "page",
  Plus = "plus",
  Podcast = "podcast",
  ScmpFilms = "scmp_films",
  Search = "search",
  Section = "section",
  Series = "series",
  Spotlight = "spotlight",
  StoryCard = "story-card",
  SubSection = "subsection",
  TalkingPost = "talking_post",
  Topic = "topic",
  TopicCollection = "topic_collection",
  Topics = "topics",
  VideoHomepage = "video-homepage",
  VideoSection = "video-section",
}
